import {Dispatch} from 'redux';
import {BESport} from 'API/types';
import {
  SPORTEVENTS_BY_COMPETITION_MONTH_GET_INVALIDATE,
  SPORTEVENTS_BY_COMPETITION_MONTH_GET_REQUEST,
  SPORTEVENTS_BY_COMPETITION_MONTH_GET_RESPONSE,
} from '../../actionTypes';
import {
  SportEventsByCompetitionAndMonthGetInvalidateAction,
  SportEventsByCompetitionAndMonthGetRequestAction,
  SportEventsByCompetitionAndMonthGetResponseAction,
} from '../types';
import {sportEventsByCompetitionIdAndMonth} from '../../../API/sportEvents';
import {MatchSimple} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {beMatchSimpleToMatchSimple} from '../../../API/utils';

/**
 *  Action creator for the get request of the sport events by competition and month
 * @param competitionId
 * @param month in format 'yyyy-MM'
 */
const getSportEventsByCompetitionTypeGetRequest = (
  competitionId: string,
  month: string
): SportEventsByCompetitionAndMonthGetRequestAction => ({
  type: SPORTEVENTS_BY_COMPETITION_MONTH_GET_REQUEST,
  payload: {
    competitionId,
    month,
  },
});

/**
 * Action creator for the request response of the sport events by competition and month
 * @param matches
 */
const getSportEventsByCompetitionTypeGetResponse = (
  matches: MatchSimple[]
): SportEventsByCompetitionAndMonthGetResponseAction => ({
  type: SPORTEVENTS_BY_COMPETITION_MONTH_GET_RESPONSE,
  payload: {matches},
});

/**
 * Action creator for the request invalidate of the sport events by competition and month
 * @param error
 */
const getSportEventsByCompetitionTypeGetInvalidate = (
  error: Error
): SportEventsByCompetitionAndMonthGetInvalidateAction => ({
  type: SPORTEVENTS_BY_COMPETITION_MONTH_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * Getting matches by competitionId and month
 * @param competitionId
 * @param month in format 'yyyy-MM'
 */
const getSportEventsByCompetitionTypeAndMonth = (competitionId: string, month: string) => (
  dispatch: Dispatch
): Promise<any> => {
  dispatch(getSportEventsByCompetitionTypeGetRequest(competitionId, month));

  return (
    sportEventsByCompetitionIdAndMonth(competitionId, month)
      // TODO: remove filters
      .then(data =>
        data.filter(match =>
          [BESport.SOCCER, BESport.BASKETBALL, BESport.TENNIS, BESport.HANDBALL, BESport.VOLLEYBALL].includes(match.sportType)
        )
      )
      .then(data => data.map(beMatchSimpleToMatchSimple))
      .then((matches: MatchSimple[]) =>
        dispatch(getSportEventsByCompetitionTypeGetResponse(matches))
      )
      .catch((error: Error) => dispatch(getSportEventsByCompetitionTypeGetInvalidate(error)))
  );
};

export default getSportEventsByCompetitionTypeAndMonth;
